import { Page } from '@/core/architecture'

import { ConsoleMembershipExplainTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMembershipExplain Page
 * Implemented as a practical sample.
 */
export const ConsoleMembershipExplain: Page = () => {
  const { state } = useViewModel()

  return <ConsoleMembershipExplainTemplate state={state} />
}
